import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { Camera } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/smGwoetaCHd37K33RY9Pro/instasaved-05-06-2026_(2).jpg',
  alt: 'Diseño de uñas rosa con detalles dorados y relieve'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wxdikMJVWZzULh7zqJcrq8/instasaved-05-06-2026_(4).jpg',
  alt: 'Uñas almendradas con arte 3D dorado y carey'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bSRFXarHvsv6jNkQwhxYds/instasaved-05-06-2026_(5).jpg',
  alt: 'Uñas con diseño floral rosa y amarillo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pA2FyKK5GL9mwvJteaNgqg/instasaved-05-06-2026_(6).jpg',
  alt: 'Manicura francesa clásica con acabado impecable'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2nkgwmqu3TKEidPuCsf1WM/instasaved-05-06-2026.jpg',
  alt: 'Uñas efecto mármol azul con líneas plateadas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r5fM6GXBy38c3jvEK32JaD/instasaved-05-06-2026_(1).jpg',
  alt: 'Diseño de uñas elegante con detalles metálicos'
}];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    scale: 0.92,
    y: 30
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function Gallery() {
  return <section className="bg-brand-ivory py-24" id="galeria" aria-labelledby="galeria-title" data-id="element-33">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="text-center mb-16" data-id="element-35">
          <Camera className="w-8 h-8 text-brand-gold mx-auto mb-4" data-id="element-36" />
          <h2 id="galeria-title" className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-37">
            El trabajo habla por sí solo
          </h2>
          <p className="text-brand-charcoal/70 max-w-2xl mx-auto" data-id="element-38">
            Cada diseño es técnica, dedicación y detalle. Así se ven las uñas
            que duran +21 días.
          </p>
          <div className="w-24 h-px bg-brand-gold mx-auto mt-6" data-id="element-39"></div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={staggerContainer} className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-40">
          {images.map((img, i) => <motion.figure key={i} variants={item} whileHover={{
          y: -6
        }} className={`group relative overflow-hidden rounded-2xl shadow-sm border border-brand-blush/30 bg-brand-cream ${i === 0 ? 'col-span-2 md:col-span-2 md:row-span-2' : ''}`} data-id="element-41">
              <div className="aspect-square w-full overflow-hidden" data-id="element-42">
                <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" data-id="element-43" />
              </div>
              <div className="absolute inset-0 bg-brand-charcoal/0 group-hover:bg-brand-charcoal/20 transition-colors duration-500" data-id="element-44" />
            </motion.figure>)}
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mt-12" data-id="element-45">
          <a href="#contacto" className="inline-flex items-center justify-center bg-brand-gold text-white px-8 py-3.5 rounded-full text-sm font-medium hover:bg-brand-goldDark transition-colors shadow-sm" data-id="element-46">
            Quiero las mías
          </a>
        </motion.div>
      </div>
    </section>;
}